import React from "react"
import PropTypes from "prop-types"
import { Badge } from "antd"
import styles from "./FilterBadge.module.css"

export default function FilterBadge({ count }) {
  if (!count) return null
  return (
    <Badge
      count={count}
      color="#1976f6"
      className={styles.filterBadge}
    />
  )
}

FilterBadge.propTypes = {
  count: PropTypes.number
}
